// extracted by mini-css-extract-plugin
export default {"root":"TableHead_root__cgXqZ"};